var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconRnd48Line = function SvgIconRnd48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.39 37.67 37.75 34a6.63 6.63 0 1 0-2.41 2.4L39 40.07l2.39-2.4Zm-9.33-3.75a3.18 3.18 0 1 1 3.17-3.18 3.19 3.19 0 0 1-3.17 3.18Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.08 35.3H13.92a1.91 1.91 0 0 1-1.57-3L19.47 22a1.65 1.65 0 0 0 .3-1v-8.3h4.6V21c-.005.356.1.706.3 1L26 23.86a9.313 9.313 0 0 1 2.92-1.75l-1.13-1.64V12.7h2.3V9.3h-16v3.4h2.3v7.77L9.55 30.4a5.3 5.3 0 0 0 4.37 8.3h13.54a9.34 9.34 0 0 1-3.38-3.4Z",
    fill: "current"
  })));
};
export default SvgIconRnd48Line;